import React from "react";

// This function will prevent crashes on web related to the native react-native-google-cast library
export const GoogleCastButton = () => {
  return null;
};
